import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export interface MarketingInsight {
  classification: string;
  [key: string]: unknown;
}

/**
 * Structured counterfactual data attached to the hero when PRD §3 fires
 * (customer YoY traffic outpaces market YoY search demand by ≥10pp).
 * Powers the tooltip on the marketing dashboard's Insights KPI tile.
 */
export interface MarketingHeroCounterfactual {
  customerYoyTrafficPct: number;
  marketYoyDemandPct: number;
  gapPp: number;
  protectedRevenue: number;
  convRate: number;
  aov: number;
}

export interface MarketingHero {
  type?: string;
  title?: string;
  narrative?: string;
  classification?: string;
  metric?: number;
  counterfactual?: MarketingHeroCounterfactual;
}

export interface MarketingInsightsResponse {
  hero?: MarketingHero;
  additional: MarketingInsight[];
  [key: string]: unknown;
}

export function useMarketingInsights(userId: string) {
  return useQuery<MarketingInsightsResponse>({
    queryKey: ["marketing-insights", userId],
    queryFn: () => api.marketing.insights.get(userId) as Promise<MarketingInsightsResponse>,
    enabled: !!userId,
    staleTime: 60_000,
  });
}
